module.exports = __webpack_public_path__ + "img/7_u.cb2da613.jpg";